import { AxiosPromise } from 'axios';

import {
  FirstLoginFeature,
  FirstLoginPayload,
  FirstLoginResponse,
  FirstLoginUserProfile,
  RegistrationFieldConfig,
} from 'interfaces/subscribe.types';
import { api } from './api';

/**
 * Service API pour le formulaire unifié inscription / 1ère connexion.
 * Chaque méthode correspond à un appel backend identifié.
 */
export class SubscribeAPI {
  /**
   * Vérifie si l'utilisateur a accès à la page de 1ère connexion
   * et retourne ses informations pré-remplies.
   * GET /auth/first-login
   */
  static getFirstLoginUser(): AxiosPromise<FirstLoginUserProfile> {
    return api.get('/auth/first-login');
  }

  /**
   * Récupère la configuration des champs du formulaire d'inscription
   * définie dans le BO.
   * GET /config/registration-field-configs
   */
  static getRegistrationFieldConfigs(): AxiosPromise<{
    fields: RegistrationFieldConfig[];
  }> {
    return api.get('/config/registration-field-configs');
  }

  /**
   * Récupère la feature flag de 1ère connexion.
   * GET /features?name=first_login
   */
  static getFirstLoginFeature(): AxiosPromise<FirstLoginFeature[]> {
    return api.get('/features?name=first_login');
  }

  /**
   * Soumet le formulaire de 1ère connexion.
   * POST /auth/first-login
   */
  static submitFirstLogin(
    payload: FirstLoginPayload,
  ): AxiosPromise<FirstLoginResponse> {
    return api.post('/auth/first-login', payload);
  }

  /**
   * Renvoie l'email de 1ère connexion à partir d'un token expiré.
   * POST /auth/first-login/resend
   */
  static resendFirstLoginEmail(resendToken: string): AxiosPromise<{ message: string }> {
    return api.post('/auth/first-login/resend', { resendToken });
  }

  /**
   * Vérifie si un email est déjà utilisé.
   * POST /users/check-email
   */
  static checkEmailExists(email: string): AxiosPromise<{ status: boolean }> {
    return api.post('/users/check-email', { email });
  }

  /**
   * Vérifie si un matricule est déjà utilisé.
   * POST /users/check-matricule
   */
  static checkMatriculeExists(
    clientId: string,
  ): AxiosPromise<{ status: boolean }> {
    return api.post('/users/check-matricule', { clientId });
  }

  /**
   * Vérifie si un code de parrainage est valide.
   * POST /users/check-referral-code
   */
  static checkReferralCode(
    referralCode: string,
  ): AxiosPromise<{ message: boolean }> {
    return api.post('/users/check-referral-code', { referralCode });
  }
}
